<template functional>
    <span v-bind:class="['dml-label', `dml-label--${props.type}`]">
        <slot />
    </span>
</template>
<script>
    export default {
        name: 'dm-product-label',
        props: {
            type: {
                type: String,
                default: 'promo'
            },
        },
    };
</script>
